<template>
  <div :class="['definition-wrapper', 'mono-choice', definition.id, {'error_validate': mandatoryValidation}, {'ok_validate': !mandatoryValidation && monoChoiceValue && (monoChoiceValue.key || monoChoiceValue.length > 0)}]">
    <div v-if="editable && !gallery && !radio" class="multiselect-wrapper">
      <multiselect
        :options="getDomain()"
        track-by="value"
        label="value"
        :placeholder="getPlaceholder()"
        :selectLabel="getLang('enterForSelect')"
        :deselectLabel="getLang('enterForDelete')"
        :preserveSearch="true"
        :class="[{'choiceWithTask': definition.task && definition.task.length > 0 && editable}]"
        v-model="monoChoiceValue"
        @input="valueChanged"
        @open="openValue"
        @close="closeValue"
      >
        <template slot="singleLabel" slot-scope="{ option }">
          <i v-if="isIcons()" :class="['sherpa-icon','icon-' + option.key]"></i>
          {{ option.value }}
        </template>
        <template v-if="isIcons()" slot="option" slot-scope="{ option }">
          <i :class="['sherpa-icon','icon-' + option.key]"></i>
          <span> {{ option.value }} </span>
        </template>
        <template slot="noResult">
          {{ getLang('noResults') }}
        </template>
        <span v-bind:class="{'active':isOpen}" class="arrow" slot="caret"><i class="fa fa-angle-down fa-2x"></i></span>
      </multiselect>
    </div>
    <div v-else-if="editable && radio" class="radio-wrapper">
      <p-radio v-for="(domain) in getDomain()" :key="domain.key"
        :name="definition.id"
        :class="[getPrettyClasses(radio), 'p-smooth', 'p-bigger', {'p-locked': !editable}]"
        color="primary"
        :value="domain.key"
        v-model="radioValue"
        @click.native="radioClick(domain.key)"
      >
        {{ domain.value }}
      </p-radio>
    </div>
    <div v-else-if="editable && gallery && showCarousel" class="gallery-wrapper">
      <carousel
        id="emailCarousel"
        class="w3-container w3-show"
        ref="carousel"
        :scrollPerPage="true"
        :perPage="perPageSlides"
        paginationActiveColor="#ff7643"
        paginationColor="#fff"
        :paginationSize="12"
        :navigationEnabled="true"
        navigationNextLabel="<i id='toggle_control_panel' class='fa fa-angle-right'></i>"
        navigationPrevLabel="<i id='toggle_control_panel' class='fa fa-angle-left'></i>"
      >
        <slide v-for="domain in getDomain()" :key="domain.key"
          :class="{'selected' : isSelected(domain.key)}"
        >
          <div class="slide-wrapper" v-on:click="valueChanged(domain)">
            <div class="gallery-img-wrapper">
              <img :src="domain.value" class="gallery-img" />
              <div if="isLangLegend()" class="lang-legend">
                <span>{{ getLangCode() }}</span>
              </div>
            </div>
            <span class="gallery-title">{{ domain.desc }}</span>
          </div>
        </slide>
      </carousel>
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :visualDefinition="visualDefinition" />
    <definition-task :class="[getDefinitionFieldClassTaskClass()]" v-if="definition.task && definition.task.length > 0 && editable"
      :definition="definition" :object="object" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
      @refreshDefinition="taskValueChanged" @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
    />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionTask from './task'
import Multiselect from 'vue-definition-utils/src/utils/multiselect' // 'vue-multiselect ^2.1.6' component with TMD modifications
import moment from 'moment'
import transport from 'vue-definition-utils/src/utils/transport'
import { Carousel, Slide } from 'vue-carousel-tmd'
import language from '../language'

export default {
  name: 'definition-mono-choice',
  props: [
    'definition',
    'object',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'gallery',
    'radio',
    'parentRepeatableGroupOpen',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'placeholder',
    'showCarousel'
  ],
  components: {
    DefinitionReadOnly,
    DefinitionTask,
    Multiselect,
    Carousel,
    Slide
  },
  data () {
    return {
      monoChoiceValue: null,
      isOpen: false,
      perPageSlides: 6,
      radioValue: null,
      radioValueAux: null
    }
  },
  methods: {
    // 1. Launch validate mandatory event on value change
    valueChanged (domain) {
      var value = []
      if (!this.gallery) {
        if (this.monoChoiceValue) {
          value.push(this.monoChoiceValue)
        }
      } else {
        value.push(domain)
      }
      this.object.domainValue = value
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    taskValueChanged (object) {
      this.$emit('refreshDefinition', object)
    },
    closeValue () {
      this.isOpen = false
    },
    openValue () {
      this.isOpen = true
    },
    isExpanded () {
      var visualDef = this.visualDefinition.getDefinitionFields(this.definition.id)
      return visualDef && visualDef.class && visualDef.class.search('expanded') >= 0
    },
    isIcons () {
      var visualDef = this.visualDefinition.getDefinitionFields(this.definition.id)
      return visualDef && visualDef.class && visualDef.class.search('icons') >= 0
    },
    isLangLegend () {
      var visualDef = this.visualDefinition.getDefinitionFields(this.definition.id)
      return visualDef && visualDef.class && visualDef.class.search('lang-legend') >= 0
    },
    isSelected (domainKey) {
      return this.object.domainValue && this.object.domainValue.length > 0 && domainKey === this.object.domainValue[0].key
    },
    selectedGalleryPage () {
      var result = 0
      if (this.object.domainValue && this.object.domainValue.length > 0) {
        var domainIndex = -1
        for (var i = 0; i < this.definition.validation.domain.length && domainIndex < 0; i++) {
          if (this.definition.validation.domain[i].key === this.object.domainValue[0].key) {
            domainIndex = i
          }
        }
        if (domainIndex > -1) {
          result = parseInt(domainIndex / this.perPageSlides)
        }
      }
      return result
    },
    loadGalleryVisibility () {
      if (this.editable && this.gallery) {
        setTimeout(() => {
          if (this.$refs.carousel) {
            this.$refs.carousel.onResize()
            this.$refs.carousel.goToPage(this.selectedGalleryPage())
          }
        }, 200)
      }
    },
    getLang (key) {
      return language(this.language, key)
    },
    getLangCode () {
      return this.getLang().substr(0, 2).toUpperCase()
    },
    radioClick (key) {
      if (this.radioValueAux === key) {
        this.radioValue = null
        this.radioValueAux = null
      } else {
        this.radioValue = key
        this.radioValueAux = key
      }
      var domain = transport.methods.getDomainValue(this.definition.validation.domain, this.radioValue)
      this.monoChoiceValue = domain
      this.valueChanged()
    },
    getPrettyClasses (classesStr) {
      var result = ''
      var classes = classesStr.split(' ')
      if (classes) {
        for (var i = 0; i < classes.length; i++) {
          if (classes[i].substr(0, 2) === 'p-') {
            result += ' ' + classes[i]
          }
        }
      }
      return result
    },
    getPlaceholder () {
      var result = this.placeholder
      if (!result) {
        result = this.getLang('select')
      }
      return result
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getDefinitionFieldClassTaskClass () {
      var result = null
      var definition = this.visualDefinition.getDefinitionFields(this.definition.id)
      if (definition) {
        result = definition.tasks
      }
      return result
    },
    getDomain () {
      var result = []
      if (this.definition.validation.domain) {
        for (var i = 0; i < this.definition.validation.domain.length; i++) {
          if (this.definition.validation.domain[i].visible) {
            result.push(this.definition.validation.domain[i])
          }
        }
      }
      return result
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    }
  },
  beforeMount () {
    if (this.object && this.definition.validation) {
      this.monoChoiceValue = transport.methods.getCheckedDomainValues(this.object.domainValue, this.definition.validation.domain)
      if (!this.monoChoiceValue) {
        this.monoChoiceValue = []
      }
      this.object.domainValue = this.monoChoiceValue

      if (this.monoChoiceValue && this.monoChoiceValue.length === 1) {
        this.radioValue = this.monoChoiceValue[0].key
        this.radioValueAux = this.monoChoiceValue[0].key
      }
    }
  },
  mounted () {
    this.loadGalleryVisibility()
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      }
    },
    object (value) {
      if (value && value.domainValue) {
        this.monoChoiceValue = value.domainValue
      }
      if (this.monoChoiceValue.length === 1) {
        this.radioValue = this.monoChoiceValue[0]
        this.radioValueAux = this.monoChoiceValue[0]
      } else if (!this.monoChoiceValue || this.monoChoiceValue.length === 0) {
        this.radioValue = null
        this.radioValueAux = null
      }
    },
    parentRepeatableGroupOpen (parentRepeatableGroupOpen) {
      if (parentRepeatableGroupOpen) {
        this.loadGalleryVisibility()
      }
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  height: 33px !important;
  min-height: 33px !important;
}
.multiselect--active {
  border: 1px solid #3485FE;
}
.multiselect__option {
  font-size: 12px;
}
.multiselect__tags {
  padding: 3px 40px 0 4px;
  font-size: 14px;
  min-height: 33px;
  height: 33px;
  border-radius: 3px;

  .multiselect__tag {
    padding: 3px 25px 3px 10px;
    font-size: 14px;
    font-family: inherit;
    margin-bottom: 0;

    .multiselect__tag-icon {
      margin-right: 1px;

      &:after {
        font-size: 24px;
        line-height: 18px;
      }
    }
  }
  .multiselect__input {
    font-size: 14px;
    font-family: inherit;
    border: 0 !important;
  }
  .multiselect__single {
    font-size: 14px;
    margin-bottom: 0;
    overflow: hidden;
    font-family: inherit;
    padding-left: 0;
  }
  .multiselect__placeholder {
    padding: 0 0 0 4px;
    font-size: 14px;
    margin-bottom: 0;
    font-family: inherit;
  }
}
.multiselect__content-wrapper {
  .multiselect__option--highlight {
    background: #13BD38 !important;

    &:after {
      background: #13BD38 !important;
    }
  }
}
.multiselect__option--selected{
  &.multiselect__option--highlight {
    background: #FF3654 !important;

    &:after {
      background: #FF3654 !important;
    }
  }
}
.radio-wrapper {
  float: left;
}
.pretty {
  margin-bottom: 10px;
}
.multiselect__tags {
  border: 1px solid #e8e8e8;
  border-radius: 2px !important;
  font-size: 14px;
  height: 33px !important;
  min-height: 33px !important;
  padding: 6px 28px 0 8px !important;
}
.multiselect__tags .multiselect__single {
  overflow-x: hidden;
}
.multiselect__tag {
  margin-bottom: 0;
}
.multiselect__option--selected {
  background-color: #dddddd;
}
.arrow {
  position: absolute;
  right: 10px;
  top: 7px;
  color: #ffbd42;
  transition: transform .2s;

  i {
    font-size: 21.6px;
  }
}
.arrow.active {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.choiceWithTask {
  float: left;
  width: 100%;
}
.gallery-wrapper {
  border-radius: 3px;

  .VueCarousel-slide {
    position: relative;
    background-color: transparent;
    color: #fff;
    text-align: center;
    cursor: pointer;
    opacity: 0.65;
    border-radius: 3px;
    transition: all 0.2s ease-in;

    .slide-wrapper {
      border-radius: 3px;
      margin: 4px 4px 18px;
      padding: 10px 0 8px;
      transition: all 0.2s ease-in;
      border: 2px solid #e0e0e0;
      transition: all 0.2s ease-in;

      &:after {
        transition: all 0.2s ease-in;
      }

      .gallery-img-wrapper {
        max-height: 500px;
        min-height: 500px;
        overflow: hidden;
        border-radius: 3px;
        margin: 0 10px;
        transition: all 0.2s ease-in;
        background-color: #fff;
        position: relative;

        .gallery-img {
          width: 100%;
        }

        .lang-legend {
          color: #ff7643;
          text-transform: uppercase;
          font-size: 14px;
          border-radius: 3px;
          font-family: Capriola;
          background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #d9d9d9 50%, #d9d9d9 100%);
          width: 45px;
          position: absolute;
          bottom: 0;
          right: 0;
          height: 45px;
          overflow: hidden;

          span {
            transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            display: inline-block;
            position: absolute;
            bottom: 4px;
            right: 5px;
          }
        }
      }

      .gallery-title {
        margin-top: 10px;
        font-size: 1.1em;
        color: #4599a4;
        font-weight: 400;
        display: block;
        padding: 8px 0 10px;
        margin: 8px 10px 0;
        background-color: #fff;
        color: #4599a4;
        border-radius: 4px;
        transition: all 0.2s ease-in;
      }
    }

    &:hover,
    &.selected {
      opacity: 1;

      .slide-wrapper {
        background-color: #fff;
        border: 2px solid #ff7643;
      }
    }

    &.selected {
      .slide-wrapper:after {
        content:'';
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -36px;
        width: 0;
        height: 0;
        border-top: solid 19px #ff7643;
        border-left: solid 36px transparent;
        border-right: solid 36px transparent;
      }
    }
  }

  .VueCarousel-navigation-button {
    font-size: 3em;
    color: #ff7643;
  }
  .VueCarousel-navigation--disabled {
    opacity: 0.3;
  }

  .VueCarousel-dot {
    margin-top: 0px !important;
  }
  .label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/monoChoice.vue